module.exports = __webpack_public_path__ + "img/7.d8f00324.png";